import { RESOURCES, type UnitWire } from '../../shared/types'
import { RES_ICON } from '../ui/panels'
import { statusAlpha } from './status'

/** Keep the hauling crate, with its actual cargo stamped on the front.
 * Stolen cargo gets a red frame and a distinct alert, in both game views. */
export function drawStatusBadge(ctx: CanvasRenderingContext2D, icon: string, u: UnitWire, x: number, y: number, size: number): void {
  ctx.save()
  ctx.globalAlpha = statusAlpha(icon)
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  const looting = !!u.raidLoot && Object.values(u.carrying ?? {}).some(n => (n ?? 0) > 0)
  const hauling = looting || icon === '📦' || icon === '🧺'
  const cargo = hauling ? (!looting && u.craftHaul ? [u.craftHaul] : RESOURCES
    .filter(res => (u.carrying?.[res] ?? 0) > 0)
    .sort((a, b) => (u.carrying?.[b] ?? 0) - (u.carrying?.[a] ?? 0))) : []
  if (!cargo.length) {
    // Empty trips keep the ordinary symbol; never suggest a load before pickup.
    ctx.font = `${size}px system-ui, sans-serif`
    ctx.fillText(icon, x, y)
    ctx.restore()
    return
  }

  // A small wood frame and lid read as the same hauling symbol, with a dark
  // inset that keeps the resource legible against terrain and the crate itself.
  const width = size * (cargo.length > 1 ? 2 : 1.5), height = size * 1.45
  const left = x - width / 2, top = y - height / 2
  ctx.fillStyle = looting ? '#431c1b' : '#35281c'
  ctx.strokeStyle = looting ? '#ff9a82' : '#d6b782'
  ctx.lineWidth = size * .09
  ctx.beginPath(); ctx.roundRect(left, top, width, height, size * .18); ctx.fill(); ctx.stroke()
  ctx.fillStyle = looting ? '#b54b3a' : '#b5915f'
  ctx.fillRect(left + size * .08, top + size * .06, width - size * .16, size * .2)
  ctx.fillStyle = '#eee0bd'
  ctx.font = `${size * .92}px system-ui, sans-serif`
  const shown = cargo.slice(0, 2)
  shown.forEach((res, i) => {
    const dx = shown.length === 1 ? 0 : (i - .5) * size * .94
    ctx.fillText(RES_ICON[res], x + dx, y + size * .18)
  })
  if (cargo.length > 2) {
    ctx.font = `700 ${size * .65}px system-ui, sans-serif`
    ctx.fillText('+', left + width, top)
  }
  if (looting) {
    const cx = left + width, cy = top + height
    ctx.fillStyle = '#431c1b'
    ctx.strokeStyle = '#ff9a82'
    ctx.lineWidth = size * .06
    ctx.beginPath(); ctx.arc(cx, cy, size * .5, 0, Math.PI * 2); ctx.fill(); ctx.stroke()
    ctx.fillStyle = '#fff0d8'
    if (icon === '⚔️' || icon === '💨') {
      ctx.font = `${size * .75}px system-ui, sans-serif`
      ctx.fillText(icon, cx, cy)
    } else {
      // Geometry keeps the alert legible without relying on emoji support or color.
      ctx.fillRect(cx - size * .07, cy - size * .29, size * .14, size * .32)
      ctx.fillRect(cx - size * .07, cy + size * .13, size * .14, size * .14)
    }
  } else if (u.state === 'waitingStorage') {
    const cx = left + width, cy = top + height
    ctx.fillStyle = '#35281c'
    ctx.beginPath(); ctx.arc(cx, cy, size * .42, 0, Math.PI * 2); ctx.fill()
    ctx.fillStyle = '#f1c65c'
    for (const dx of [-.17, .06]) ctx.fillRect(cx + size * dx, cy - size * .23, size * .11, size * .46)
  }
  ctx.restore()
}
